module.exports = __webpack_public_path__ + "media/bootstrap-icons/gender-female-b44cb37d.svg";